<template>
    <div class="container-fluid">
        <!-- sign up -->
        <div class="row bg-black">
            <div class="user-account">

                <user-account-header :user="user"></user-account-header>

                <!-- user tabs actions -->
                <div class="user-actions">
                    <div class="container">
                        <div class="tabs-container">
                            <div class="tabs-left">
                                <ul class="nav nav-tabs sections-profile-tabs col-xs-12 col-sm-3 ticket-details">
                                    <div class="ticket-detail">
                                        <p>Request #</p>
                                        <span>{{ ticketDetails.id }}</span>
                                    </div>
                                    <div class="ticket-detail">
                                        <p>Subject</p>
                                        <span>{{ ticketDetails.subject }}</span>
                                    </div>
                                    <div class="ticket-detail">
                                        <p>Status</p>
                                        <span>{{ ticketDetails.status }}</span>
                                    </div>
                                    <div class="ticket-detail">
                                        <p>Region</p>
                                        <span>{{ ticketDetails.region | replace('_', ' ') }}</span>
                                    </div>
                                    <div class="ticket-detail">
                                        <p>Product</p>
                                        <span>{{ ticketDetails.product }}</span>
                                    </div>
                                    <div class="ticket-detail">
                                        <p>Department</p>
                                        <span>{{ ticketDetails.department | replace('_', ' ') }}</span>
                                    </div>
                                </ul>
                                <div class="tab-content col-xs-12 col-sm-9 p-a-0 comments-col">
                                    <div v-show="!loadingTicketDetails" class="tab-pane active">
                                        <div v-for="comment in comments" :key="comment.id" class="comment-wrapper row">
                                            <div class="col-sm-2 col-xs-2">
                                                <img :src="comment.author.photo || '/images/users/avatar.png'" class="img-responsive">
                                            </div>
                                            <div class="col-md-8 col-sm-10 col-xs-10">
                                                <div class="comment-username">{{ comment.author.name }}</div>
                                                <div class="comment-date" :title="comment.created_at | formatDate">{{ comment.relative_created_at }}</div>
                                                <div class="comment" v-html="comment.html_body"></div>
                                                <ul class="comment-attachments">
                                                    <li v-for="attachment in comment.attachments" :key="attachment.id">
                                                        <a :href="attachment.content_url" target="_blank">{{ attachment.file_name }}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="comment-wrapper comment-form row">
                                            <form @submit.prevent="saveAttachments">
                                                <div class="col-sm-2 col-xs-2">
                                                    <!-- Once we store the user avatar uncomment this -->
                                                    <!-- <img :src="user.photo" class="img-responsive" /> -->
                                                    <img @error="setDefaultAvatar" :src="user.photo || '/images/users/avatar.png'" class="current-user-avatar img-responsive">
                                                </div>
                                                <div class="col-md-8 col-sm-10 col-xs-10">
                                                    <div class="form-group">
                                                        <textarea
                                                            autofocus
                                                            class="form-control"
                                                            data-vv-as="message"
                                                            v-validate="'required'"
                                                            v-model.trim="commentBody"
                                                            name="message"
                                                            rows="4"></textarea>

                                                        <span v-show="errors.has('message')" class="help is-danger">
                                                            {{ errors.first('message') }}
                                                        </span>
                                                    </div>
                                                    <div class="form-group">
                                                        <label for="comment-attachment" v-validate="'image'">Attachment</label>
                                                        <input id="comment-attachments" name="comment-attachments" type="file" multiple accept="image/*">
                                                    </div>
                                                    <div class="form-group">
                                                        <router-link :to="{name: 'UserAccount', query: { currentTab: 'tickets' }}" class="btn btn-green btn-outline">Back</router-link>
                                                        <button class="btn btn-green btn-outline">Submit</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div v-show="loadingTicketDetails" class="tab-pane active">
                                        <div style="color: white" class="text-center">
                                            <span class="fa fa-spin fa-spinner"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.user tabs actions -->
                <!-- /.Welcome Title with User Name -->
            </div>
        </div>
        <!-- /.sign up -->
    </div>
</template>
<script>

import UserAccountHeader from "./user-account-header.vue";
import { getUserData } from "../../util/helpers.js";

export default {
    name: "ticket-details",
    data() {
        return {
            loadingTicketDetails: false,
            user: getUserData(),
            ticketDetails: {
                id: '',
                subject: '',
                status: '',
                region: '',
                product: '',
                department: '',
            },
            comments: {},
            commentBody: ""
        }
    },
    filters: {
        formatDate(date) {
            return moment(date).format("YYYY-MM-DD hh:mm:ss a")
        }
    },
    created() {
        this.getTicketDetails();
    },
    methods: {
        setDefaultAvatar() {
            $(".current-user-avatar").attr("src", '/images/users/avatar.png');
        },
        getTicketDetails() {
            this.loadingTicketDetails = true;
            const ticketId = this.$route.params.id;
            axios.get(`tickets/${ticketId}`).then(response => {
                if (response.data.status == "danger") {
                    setTimeout(() => {
                        toastr.error(response.data.message, "Error", { timeOut: 8000});
                        this.$router.push({ name: 'UserAccount', query: {
                            redirect: '/user/account',
                            currentTab: 'tickets'
                        }});
                    }, 0);
                    return;
                }
                this.ticketDetails = response.data.ticket.ticket;
                this.comments = response.data.comments;
                this.ticketDetails.region = response.data.ticket.ticket.custom_fields[0].value;
                this.ticketDetails.product = response.data.ticket.ticket.custom_fields[1].value;
                this.ticketDetails.department = response.data.ticket.ticket.custom_fields[2].value;

                Object.keys(this.comments).forEach(comment => {
                    this.comments[comment].relative_created_at = moment(this.comments[comment].created_at, 'YYYYMMDD').startOf('day').fromNow();
                });
            }).catch(error => {
                toastr.error(error.response.data.status.message);
            }).finally(() => this.loadingTicketDetails = false)
        },
        async saveAttachments(){
            const isValid = await this.$validator.validateAll();
            if (!isValid) return;
            this.loadingTicketDetails = true;
            const inputFiles = document.querySelector('#comment-attachments');
            const formData = new FormData();
            Object.keys(inputFiles.files).forEach(file => {
                formData.append(`attachment-${file}`, inputFiles.files[file]);
            });

            axios.post(`tickets-attachments`, formData).then(response => {
                this.saveComment(response.data);
            }).catch(error => {
                this.loadingTicketDetails = false;
                toastr.error(error.response.data.status.message);
            });
        },
        saveComment(attachments) {
            const ticketId = this.$route.params.id;
            const formData = new FormData();

            formData.append('body', this.commentBody);

            attachments.forEach(attachment => {
                formData.append(`attachments[]`, attachment);
            });

            axios.post(`tickets/${ticketId}/comments`, formData).then(response => {
                document.querySelector('#comment-attachments').value = '';
                this.commentBody = '';
                toastr.success('Your reply was successfully added.');
                this.getTicketDetails();
            }).catch(error => {
                this.loadingTicketDetails = false;
                toastr.error(error.response.data.status.message);
            });
        }
    },
    components: {
        UserAccountHeader,
    }
}
</script>
<style lang="scss" scoped>
.comments-col {
    padding: 28px 56px;
    overflow-y: auto;
    font-size: 18px;
    height: 715px;

    .comment-wrapper {
        color: white;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        padding-top: 20px;
        padding-bottom: 20px;

        .comment-username {
            font-weight: bold;
        }

        .comment-date {
            font-size: 16px;
            color: rgba(255, 255, 255, 0.5);
        }

        .comment {
            margin-top: 20px;
        }
    }

    .comment-form {
        textarea {
            color: black;
            width: 100%;
            padding: 10px;
        }
    }
}

.ticket-details {
    padding: 20px !important;
}

.ticket-detail {
    color: white;
    font-size: 14px;
    padding: 10px 0;

    p {
        margin-bottom: 0;
        font-weight: bold;
    }

    span {
        text-transform: capitalize;
    }
}

.ticket-detail:first-child {
    padding-top: 0;
}
</style>
